import React, { useContext } from "react";
import { useHistory } from "react-router-dom";

import { generatePricingReportv2, getSettlementHistory } from "apis";
import { Intro } from "components/commons";
import useDataTable from "hooks/useDataTable";
import locale from "localization";

import { settlementHistoryFilterState } from "./settlement-history-filter.state";
import { mapFilterToRequest, mapDataToList } from "./settlement-history.mapper";
import { settlementHistoryColumns } from "./settlement-history-columns";
import SettlementHistoryFilter from "./settlement-history-filter";
import SettlementHistoryList from "./settlement-history.list";
import styles from "./settlement-history.module.scss";
import { useExport } from "hooks";
import { SuccessModal } from "components/modals";
import { UserContext } from "contexts";

const SettlementHistoryModule = () => {
  const history = useHistory();
  const { sessionId: connectionId } = useContext(UserContext)

  const { filter, search, table } = useDataTable({
    api: { api: getSettlementHistory },
    filter: { initialState: settlementHistoryFilterState(), mapper: mapFilterToRequest },
    table: {
      key: "settlements",
      mapper: (settlements) =>
        mapDataToList({
          settlements,
          history,
        }),
      columns: settlementHistoryColumns,
    },
  });

  const exportReport = useExport({
    api: generatePricingReportv2,
    hasModal: true,
    reportType: "settlements",
    mappedFilterState: {
      ...filter?.mappedFilterState,
      searchKey: search?.searchKey,
      settlementType: "oilco",
      connectionId
    },
  });

  return (
    <>
      <SuccessModal {...exportReport?.successModalComponent} />
      <Intro title={locale.oilcoSettlementHistory} subtitle={locale.viewTrackSettlement} />
      <SettlementHistoryFilter {...filter} {...search} {...exportReport} />
      <div className={styles.table}>
        <SettlementHistoryList table={table} />
      </div>
    </>
  );
};

export default SettlementHistoryModule;
